import { render } from "./FormEditor.vue?vue&type=template&id=9be42106"
import script from "./FormEditor.vue?vue&type=script&lang=js"
export * from "./FormEditor.vue?vue&type=script&lang=js"

import "./FormEditor.vue?vue&type=style&index=0&id=9be42106&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__